import { useCallback, useEffect, useState } from 'react';
import { downloadFile, httpDelete, httpGet, dateFormat } from '../../utils';
import { Tooltip } from '@material-ui/core';
import Icon from '../../sf-components/Icon/Icon';
import Icons from '../../sf-components/Icon/Icons';

const TOOLTIP_STYLING =
    'my-2 px-3 h-8 flex items-center text-sf font-medium bg-sf-gray-800 radius border border-sf-gray-700 shadow-sf-small';

const BackupsHistory = ({ isCreatingBackup }) => {
    const [backupsHistory, setBackupsHistory] = useState([]);

    useEffect(() => {
        if (!isCreatingBackup) {
            const getBackupsHistory = async () => {
                const response = await httpGet('/Settings/getBackupsHistory');
                setBackupsHistory(response.data.history);
            };
            getBackupsHistory();
        }
    }, [isCreatingBackup]);

    const onDeleteBackup = useCallback((index) => {
        setBackupsHistory((backupsHistory) => {
            backupsHistory.splice(index, 1);
            return [...backupsHistory];
        });
    }, []);

    return (
        <div className="p-2">
            <div className="px-3 py-2 text-xs font-medium">Backup history</div>
            {backupsHistory.map((backup, index) => (
                <Backup key={index} backup={backup} onDelete={() => onDeleteBackup(index)} />
            ))}
        </div>
    );
};

const Backup = ({ backup, onDelete }) => {
    const [showActions, setShowActions] = useState(false);

    const downloadBackup = () => {
        try {
            downloadFile(`/Settings/DownloadSystemBackup/${backup.id}`);
        } catch (err) {
            console.error(err);
        }
    };

    const deleteBackup = async () => {
        try {
            await httpDelete(`/Settings/deleteSystemBackup/${backup.id}`);
            onDelete();
        } catch (err) {
            console.error(err);
        }
    };

    const backCreationDate = dateFormat(backup.creation_date);
    return (
        <div
            className="px-3 h-12 flex justify-between items-center rounded-lg hover:bg-sf-light-100"
            onMouseLeave={() => setShowActions(false)}
            onMouseEnter={() => setShowActions(true)}>
            <div>
                <div className="text-xs font-normal pr-2 whitespace-nowrap max-w-[180px] truncate">
                    {backCreationDate}
                </div>
                {backup.creator_display_name && (
                    <div className="text-xxs font-normal text-sf-gray-500">added by {backup.creator_display_name}</div>
                )}
            </div>
            {showActions ? (
                <div className="flex gap-1">
                    <Tooltip
                        title="Download"
                        enterDelay={1000}
                        enterNextDelay={1000}
                        placement={'top'}
                        classes={{
                            tooltip: TOOLTIP_STYLING
                        }}>
                        <button
                            className="hover:bg-sf-gray-100 p-2 rounded-lg"
                            onClick={(e) => {
                                e.stopPropagation();
                                downloadBackup();
                            }}>
                            <Icon className="h-4 w-4" icon={Icons.Download} />
                        </button>
                    </Tooltip>
                    <Tooltip
                        title="Delete"
                        enterDelay={1000}
                        enterNextDelay={1000}
                        placement={'top'}
                        classes={{
                            tooltip: TOOLTIP_STYLING
                        }}>
                        <button
                            className="hover:bg-sf-gray-100 p-2 rounded-lg"
                            onClick={(e) => {
                                e.stopPropagation();
                                deleteBackup();
                            }}>
                            <Icon icon={Icons.Delete} className="h-4 w-4" />
                        </button>
                    </Tooltip>
                </div>
            ) : (
                <div className="text-xs font-normal text-sf-gray-500 overflow-hidden truncate max-w-16">
                    {backup.tower_version}
                </div>
            )}
        </div>
    );
};

export default BackupsHistory;
